import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Phone, Mail, MapPin } from "lucide-react";
import LogoWordmark from "./Logo";
import { BUSINESS } from "@/lib/data";

export default function Footer() {
  return (
    <footer className="relative border-t border-white/5 bg-[#0A0E17]" data-testid="site-footer">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <LogoWordmark />
            <p className="mt-5 text-sm text-[#9CA3AF] max-w-sm leading-relaxed">
              Atlanta's mobile car detailing crew. Pro equipment, satisfaction guaranteed,
              and yes — the pickle does show up.
            </p>
            <div className="mt-6 flex items-center gap-3">
              <a
                href={BUSINESS.instagram}
                target="_blank"
                rel="noreferrer"
                className="btn-ghost-cream w-10 h-10 rounded-full inline-flex items-center justify-center"
                data-testid="footer-instagram"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={BUSINESS.tiktok}
                target="_blank"
                rel="noreferrer"
                className="btn-ghost-cream w-10 h-10 rounded-full inline-flex items-center justify-center"
                data-testid="footer-tiktok"
                aria-label="TikTok"
              >
                <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V8.3a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.13Z"/></svg>
              </a>
            </div>
          </div>

          <div>
            <div className="label-eyebrow mb-4">Navigate</div>
            <ul className="space-y-2 text-sm">
              {["Services","Pricing","Gallery","Reviews","FAQ","Contact"].map((l) => (
                <li key={l}>
                  <a
                    href={`/#${l.toLowerCase()}`}
                    className="text-[#F5F1E8]/75 hover:text-[#7CB342] transition"
                    data-testid={`footer-link-${l.toLowerCase()}`}
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <div className="label-eyebrow mb-4">Contact</div>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start gap-2.5 text-[#F5F1E8]/80">
                <Phone size={16} className="mt-0.5 text-[#7CB342]" />
                <a href={BUSINESS.phoneHref} data-testid="footer-phone">{BUSINESS.phone}</a>
              </li>
              <li className="flex items-start gap-2.5 text-[#F5F1E8]/80 break-all">
                <Mail size={16} className="mt-0.5 text-[#7CB342]" />
                <a href={BUSINESS.emailHref} data-testid="footer-email">{BUSINESS.email}</a>
              </li>
              <li className="flex items-start gap-2.5 text-[#F5F1E8]/80">
                <MapPin size={16} className="mt-0.5 text-[#7CB342]" />
                <span>Atlanta, GA — Mobile Service</span>
              </li>
            </ul>
            <Link to="/book" className="btn-pickle inline-flex items-center justify-center rounded-full px-5 py-2.5 text-sm mt-5" data-testid="footer-book-btn">
              Book a Detail
            </Link>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#9CA3AF]">
          <span>© {new Date().getFullYear()} {BUSINESS.name}. Atlanta, GA.</span>
          <span>Made with elbow grease & dill.</span>
        </div>
      </div>
    </footer>
  );
}
